<template>
  <SkeletonLoader
    v-if="isLoading"
    show-animation
    data-testid="pagination-loading"
  >
    <div class="trade-pagination--loading" />
  </SkeletonLoader>
  <Pagination
    v-else
    data-testid="pagination"
    :total-pages="totalPages"
    :current-page="currentPage"
    @page-changed="handlePageChange"
  />
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

import { SkeletonLoader, Pagination } from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    Pagination,
    SkeletonLoader
  }
})
export default class PaginationComponent extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly isLoading!: boolean;

  @Prop({ type: Number, required: true })
  readonly totalPages!: number;

  @Prop({ type: Number, required: true })
  readonly currentPage!: number;

  handlePageChange(page: number) {
    this.$emit('page-changed', page);
  }
}
</script>

<style lang="less" scoped>
.trade-pagination {
  &--loading {
    width: 150px;
    height: @size-spacing-x600;
    margin: 0 auto;
    border-radius: 8px;
  }
}
</style>
